/**
 * NestedMenu.js
 * Nested Menu Component
 *
 * @class   Menu
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import CssEvent from 'utils/css-event';
import Dom from 'utils/dom';
import KeyLine from 'utils/key-line';
import ClassNames from 'classnames';
import ClickAway from 'mixins/js/ClickAway';
import Paper from 'components/paper/Paper';
import MenuItem from 'components/menu/MenuItem';
import LinkMenuItem from 'components/menu/LinkMenuItem';
import SubheaderMenuItem from 'components/menu/SubheaderMenuItem';

export default React.createClass({

	mixins: [ ClickAway ],

	manuallyBindClickAway: true,

	propTypes: {
		index: React.PropTypes.number.isRequired,
		text: React.PropTypes.string,
		menuItems: React.PropTypes.array.isRequired,
		zDepth: React.PropTypes.number,
		disabled: React.PropTypes.bool,
		onItemClick: React.PropTypes.func,
		onItemTap: React.PropTypes.func
	},

	getDefaultProps() {
		return {
			disabled: false
		};
	},

	getInitialState() {
		return { open: false }
	},

	componentClickAway() {
		this._closeNestedMenu();
	},

	componentDidMount() {
		this._positionNestedMenu();
	},

	componentDidUpdate(prevProps, prevState) {
		this._positionNestedMenu();

		if (this.state.open) {
			this._bindClickAway();
		} else {
			this._unbindClickAway();
		}
	},

	render() {
		let classes = ClassNames('lui-nested-menu-item', {
			'lui-open': this.state.open,
			'lui-is-disabled': this.props.disabled
		});

		return (
			<div className={classes} onMouseEnter={this._openNestedMenu} onMouseLeave={this._closeNestedMenu}>
				<MenuItem index={this.props.index} disabled={this.props.disabled} iconRightClassName="luidocs-icon-custom-arrow-drop-right" onClick={this._onParentItemClick}>
					{this.props.text}
				</MenuItem>
				<Menu
					ref="nestedMenu"
					menuItems={this.props.menuItems}
					onItemClick={this._onMenuItemClick}
					onItemTap={this._onMenuItemTap}
					hideable={true}
					visible={this.state.open}
					zDepth={this.props.zDepth + 1} />
			</div>
		);
	},

	_positionNestedMenu() {
		let el = React.findDOMNode(this),
			nestedMenu = this.refs.nestedMenu.getDOMNode();

		nestedMenu.style.left = el.offsetWidth + 'px';
	},

	_openNestedMenu() {
		if (!this.props.disabled) this.setState({ open: true });
	},

	_closeNestedMenu() {
		this.setState({ open: false });
	},

	_toggleNestedMenu() {
		if (!this.props.disabled) this.setState({ open: !this.state.open });
	},

	_onParentItemClick() {
		this._toggleNestedMenu();
	},

	_onMenuItemClick(e, index, menuItem) {
		if (this.props.onItemClick) this.props.onItemClick(e, index, menuItem);
		this._closeNestedMenu();
	},

	_onMenuItemTap(e, index, menuItem) {
		if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
		this._closeNestedMenu();
	}

});


/****************
* Menu Component
****************/
let Menu = React.createClass({

	propTypes: {
		autoWidth: React.PropTypes.bool,
		onItemTap: React.PropTypes.func,
		onItemClick: React.PropTypes.func,
		onToggleClick: React.PropTypes.func,
		menuItems: React.PropTypes.array.isRequired,
		selectedIndex: React.PropTypes.number,
		hideable: React.PropTypes.bool,
		visible: React.PropTypes.bool,
		zDepth: React.PropTypes.number
	},

	getInitialState() {
		return { nestedMenuShown: false }
	},

	getDefaultProps() {
		return {
			autoWidth: true,
			hideable: false,
			visible: true,
			zDepth: 1
		};
	},

	componentDidMount() {
		let el = React.findDOMNode(this);

		//Set the menu with
		this._setKeyWidth(el);

		//Save the initial menu height for later
		this._initialMenuHeight = el.offsetHeight + KeyLine.Desktop.GUTTER_LESS;

		//Show or Hide the menu according to visibility
		this._renderVisibility();
	},

	componentDidUpdate(prevProps, prevState) {
		if (this.props.visible !== prevProps.visible) this._renderVisibility();
	},

	render() {
		let classes = ClassNames('lui-menu', {
			'lui-menu-hideable': this.props.hideable,
			'lui-visible': this.props.visible
		});

		return (
			<Paper ref="paperContainer" zDepth={this.props.zDepth} className={classes}>
				{this._getChildren()}
			</Paper>
		);
	},

	_getChildren() {
		let children = [],
			menuItem,
			itemComponent,
			isSelected,
			isDisabled;

		//This array is used to keep track of all nested menu refs
		this._nestedChildren = [];

		for (let i=0; i < this.props.menuItems.length; i++) {
			menuItem = this.props.menuItems[i];
			isSelected = i === this.props.selectedIndex;
			isDisabled = (menuItem.disabled === undefined) ? false : menuItem.disabled;

			let {
				icon,
				data,
				attribute,
				number,
				toggle,
				onClick,
			} = menuItem;

			switch (menuItem.type) {

				case MenuItem.Types.LINK:
					itemComponent = (
						<LinkMenuItem
							key={i}
							index={i}
							payload={menuItem.payload}
							target={menuItem.target}
							text={menuItem.text}
							disabled={isDisabled} />
					);
					break;

				case MenuItem.Types.SUBHEADER:
					itemComponent = (
						<SubheaderMenuItem
							key={i}
							index={i}
							text={menuItem.text} />
					);
					break;

				case MenuItem.Types.NESTED:
					itemComponent = (
						<NestedMenuItem
							ref={i}
							key={i}
							index={i}
							text={menuItem.text}
							disabled={isDisabled}
							menuItems={menuItem.items}
							zDepth={this.props.zDepth}
							onItemClick={this._onNestedItemClick}
							onItemTap={this._onNestedItemClick} />
					);
					this._nestedChildren.push(i);
					break;

				default:
					itemComponent = (
						<MenuItem
							{...this.props}
							selected={isSelected}
							key={i}
							index={i}
							icon={menuItem.icon}
							data={menuItem.data}
							attribute={menuItem.attribute}
							number={menuItem.number}
							toggle={menuItem.toggle}
							disabled={isDisabled}
							onClick={this._onItemClick}
							onTouchTap={this._onItemTap}>
							{menuItem.text}
						</MenuItem>
					);
			}
			children.push(itemComponent);
		}

		return children;
	},

	_setKeyWidth(el) {
		let menuWidth = this.props.autoWidth ?
			KeyLine.getIncrementalDim(el.offsetWidth) + 'px' :
			'100%';

		//Update the menu width
		Dom.withoutTransition(el, function() {
			el.style.width = menuWidth;
		});
	},

	_renderVisibility() {
		let el;

		if (this.props.hideable) {
			el = React.findDOMNode(this);
			let innerContainer = this.refs.paperContainer.getInnerContainer();
			innerContainer = React.findDOMNode(innerContainer);

			if (this.props.visible) {

				//Open the menu
				el.style.height = this._initialMenuHeight + 'px';

				//Set the overflow to visible after the animation is done so
				//that other nested menus can be shown
				CssEvent.onTransitionEnd(el, ()=> {
					//Make sure the menu is open before setting the overflow.
					//This is to accout for fast clicks
					if (this.props.visible) innerContainer.style.overflow = 'visible';
				});

			} else {

				//Close the menu
				el.style.height = '0px';

				//Set the overflow to hidden so that animation works properly
				innerContainer.style.overflow = 'hidden';
			}
		}
	},

	_onNestedItemClick(e, index, menuItem) {
		if (this.props.onItemClick) this.props.onItemClick(e, index, menuItem);
	},

	_onNestedItemTap(e, index, menuItem) {
		if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
	},

	_onItemClick(e, index) {
		if (this.props.onItemClick) this.props.onItemClick(e, index, this.props.menuItems[index]);
	},

	_onItemTap(e, index) {
		if (this.props.onItemTap) this.props.onItemTap(e, index, this.props.menuItems[index]);
	},

	_onItemToggle(e, index, toggled) {
		if (this.props.onItemToggle) this.props.onItemToggle(e, index, this.props.menuItems[index], toggled);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/menu/NestedMenu.js
 **/